export default "__VITE_ASSET__BJFmONz4__"